<template>
    <div class="page bg-gray page-flex">
        <backTitleBar></backTitleBar>
        <div class="top">
            <div class="top-main">
                <div class="flex">
                    <div class="flex1 mr-20">
                        <div class="fs-28 color-fff name">可提现(元)</div>
                        <div class="money number_font">{{formatNumber(account_entity.withdrawable || 0)}}</div>
                    </div>
                    <div class="right click" @click="$router.push({name: 'withdraw'})">
                        <div class="alifont icon-tixian"></div>
                        <div class="fs-32 color-fff">提现</div>
                    </div>
                </div>
                <div class="flex fs-28 color-fff mt-25">
                    <div class="flex1">
                        <div>昨日收益</div>
                        <div class="number_font mt-5">{{formatNumber(account_entity.yestIncome || 0)}}</div>
                    </div>
                    <div class="flex1">
                        <div>待入账收益</div>
                        <div class="number_font mt-5">{{formatNumber(account_entity.waitSettleIncome || 0)}}</div>
                    </div>
                    <div class="flex1">
                        <div>累积收益</div>
                        <div class=" number_font mt-5">{{formatNumber(account_entity.cumulativeIncome || 0)}}</div>
                    </div>
                </div>
            </div>
            <van-tabs v-model="tabItemActive" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">
                <van-tab :title="item.title" :name="item.name" v-for="(item,$index) in tabList" :key="$index"></van-tab>
            </van-tabs>
        </div>
        <div class="flex-between flex-center pd-25" style="padding-bottom: 0" v-if="showIncomeCount">
            <div class="flex-center selection click" @click="popupShow = true">
                <div class="fs-28 color-333">{{currentDateShow}}</div>
                <div class="alifont icon-lujingbeifen"></div>
            </div>
            <div class="fs-28 color-333">
                收入： <span class="number_font">{{formatNumber(monthIncome)}}</span>
            </div>
        </div>
        <div class="flex1 posi-rel list mt-25">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <ul class="">
                    <div class="list-item bd-bot pd-250" v-for="(item,$index) in data" :key="$index" v-if="tabItemActive == 1">
                        <div class="flex-between fs-32 color-333">
                            <div>{{item.descp}}</div>
                            <div :class="{'color-org':item.operateType == 'minus'}"><span v-if="item.operateType == 'minus'">-</span>¥<span class="number_font">{{formatNumber(item.amount)}}</span></div>
                        </div>
                        <div class="flex-between fs-26 color-999 mt-10">
                            <div>{{item.createTime}}</div>
                            <div>{{item.logId}}</div>
                        </div>
                    </div>

                    <div class="list-item bd-bot pd-250" v-for="(item,$index) in data" :key="$index" v-if="tabItemActive == 2">
                        <div class="flex-between fs-32 color-333">
                            <div>提现</div>
                            <div>¥<span class="number_font">{{formatNumber(item.amount)}}</span></div>
                        </div>
                        <div class="flex-between fs-26 color-999 mt-10">
                            <div>{{item.createTime}}</div>
                            <div>
                                <div :class="{'color-main':item.state == 3,'color-red':item.state == 4 || item.state ==6}" v-for="dict in dicts['withdrawApply_state']" :key="dict.codeid" v-if="String(item.state) == dict.code">
                                    <span>{{ dict.codename }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="fs-24 color-red mt-8" v-if="item.state ==6">驳回原因：{{item.remark}}</div>
                    </div>


                    <div class="list-item bd-bot pd-250" v-for="(item,$index) in data" :key="$index" v-if="tabItemActive == 3">
                        <div class="flex-between fs-32 color-333">
                            <div>订单收入</div>
                            <div class="color-org">¥<span class="number_font">{{formatNumber(item.shopamt)}}</span></div>
                        </div>
                        <div class="fs-26 color-999 mt-10">
                            <div>订单号:{{item.orderNo}}</div>
                        </div>
                        <div class="color-999 mt-10">
                            {{item.createTime}}
                        </div>
                    </div>

                </ul>
            </scroller>
        </div>
        <van-popup  v-model="popupShow" position="bottom">
            <van-datetime-picker
                    v-model="currentDate"
                    type="year-month"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :formatter="formatter"
                    @confirm="datetimeConfirm"
                    @cancel="datetimeCancel"
            />
        </van-popup>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import initData from "@/mixins/initData"
    import initDict from "@/mixins/initDict"
    import util from "@/utils/index"
    import {qryShopIncome,qryShopIncomeByDate} from "@/api/account"
    export default {
        name: "incomeDetail",
        components:{backTitleBar},
        mixins: [initData,initDict],
        computed:{
            'currentDateShow':function(){
                return  this.formatDateShow(this.confirmCurrentDate)
            }
        },
        data(){
            return{
                tabItemActive:1,
                tabList:[
                    {title:'收益明细',name:1},
                    {title:'待入账明细',name:3},
                    {title:'提现明细',name:2},
                ],
                account_entity:{},
                url:'shop/shopAccountLog/list',
                currentDate: new Date(),
                confirmCurrentDate: new Date(),
                minDate: new Date(2019, 0),
                maxDate: new Date(),
                popupShow:false,
                shopId: this.$store.state.user.shopId,
                monthIncome:0,
                showIncomeCount:true,

            }
        },
        created(){
            let codeList = [
                'withdrawApply_state',
            ]
            this.getThisDict(codeList)
            this.getShopIncome();
            this.qryShopIncomeByDate();
        },
        methods:{
            beforeInit() {
                this.params = { page : this.page, limit: this.limit,shopId:this.shopId,};
                this.pageInfo = {
                    queryDate:util.formatDate(this.confirmCurrentDate,'yyyy-MM')
                }
                let query = this.pageInfo;
                for (var key in query){
                    if(query[key]){
                        this.params[key] = query[key]
                    }
                }
                return true
            },
            tabClick(name){
                let _this = this;
                switch (name) {
                    case 1:
                        _this.showIncomeCount = true;
                        _this.url = 'shop/shopAccountLog/list';
                        break;
                    case 2:
                        _this.showIncomeCount = false;
                        _this.url = 'shop/shopAccountWithdraw/list';
                        _this.pageInfo = {}
                        break;
                    case 3:
                        _this.showIncomeCount = false;
                        _this.url = 'order/orderBase/qryWaitSettleOrder';
                        _this.pageInfo = {}
                        break;
                }
                _this.handleQuery();
            },
            formatter(type, val) {
                if (type === 'year') {
                    return `${val}年`;
                } else if (type === 'month') {
                    return `${val}月`
                }
                return val;
            },
            formatDateShow(time){
                return util.formatDate(time,'yyyy年MM月')
            },
            datetimeConfirm(time){
                this.confirmCurrentDate = time;
                this.popupShow = false;
                this.handleQuery();
                this.qryShopIncomeByDate();
            },
            datetimeCancel(){
                this.popupShow = false;
            },

            //获取商家收入统计
            getShopIncome(){
                qryShopIncome({shopId: this.shopId}).then(res=>{
                    this.account_entity = res.data;
                })
            },
            //查询商家月收入
            qryShopIncomeByDate(){
                qryShopIncomeByDate({shopId:this.shopId,queryDate: util.formatDate(this.confirmCurrentDate,'yyyy-MM')}).then(res=>{
                    if(res.data && res.data.income){
                        this.monthIncome = res.data.income
                    }else{
                        this.monthIncome = 0;
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .top{
        padding: .2rem .24rem 0;
        background: #fff;
        .top-main{
            background:linear-gradient(135deg,rgba(52,122,255,1) 0%,rgba(54,189,255,1) 100%);
            border-radius: .12rem;
            padding: .36rem 0 .4rem .32rem;
            margin-bottom: .16rem;
        }
        .name{
            opacity: .8;
        }
        .money{
            font-size: .78rem;
            line-height: .94rem;
            color: #fff;
        }
        .right{
            height: .56rem;
            line-height: .56rem;
            background:rgba(0,0,0,0.11);
            border-radius: .28rem 0 0 .28rem;
            color: #fff;
            padding: 0 .25rem;
            display: flex;
            align-items: center;
            .alifont{
                font-size: .4rem;
                margin-right: .1rem;
            }
        }
    }
    .selection{
        background: #fff;
        border-radius: .36rem;
        padding: .12rem .24rem;
        .alifont{
            color: #CCCCCC;
            margin-left: .05rem;
            font-size: .1rem;
        }
    }
    .list{
        margin: 0 .24rem;
        background: #fff;
        border-radius: .12rem;
        .list-item{
            margin: 0 .24rem;
        }
    }
</style>



// WEBPACK FOOTER //
// incomeDetail.vue?a4c652be